import React from 'react';
import { motion } from 'framer-motion';

export const SuspenseFallback: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 360],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="inline-block mb-4"
        >
          <div className="w-16 h-16 border-4 border-primary-200 dark:border-primary-800 border-t-primary-600 dark:border-t-primary-400 rounded-full animate-spin" />
        </motion.div>
        <p className="text-gray-600 dark:text-gray-300 font-medium">
          Loading...
        </p>
      </div>
    </div>
  );
};

export const PageSuspenseFallback: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-4 border-primary-200 dark:border-primary-800 border-t-primary-600 dark:border-t-primary-400 rounded-full animate-spin mb-4" />
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Loading page...
        </p>
      </div>
    </div>
  );
};
